import type { CustomerAllByGroup } from "@services/apiEcms/apiEcms.types";

import type { Authorization } from "./AuthorizationsDrawer/AuthorizationsDrawer.types";

export const searchCustomer = (
  listToSearch: CustomerAllByGroup[],
  keyWord: string,
): CustomerAllByGroup[] =>
  listToSearch.filter(
    (opt) =>
      opt.customerName.includes(keyWord) || opt.customerId.includes(keyWord),
  );

export const formatAuthorizations = (selected: Authorization[]): string[] =>
  selected.reduce((acc: string[], curr) => [...acc, curr.customerId], []);

export const computeInitialSelectedState = (
  currentAuthorizations?: Authorization[] | null,
  customerList?: CustomerAllByGroup[],
) => currentAuthorizations ?? customerList ?? [];
